const errorsToString = (errorsObj: any, id: string): string => {
  if (!errorsObj || !errorsObj[id]) return '';

  const { errors } = errorsObj[id];
  if (!errors) return '';

  return errors.reduce(
    (error: string, { msg }: { msg: string }) =>
      error.length ? (error = msg) : `${error} ${msg}`,
    ''
  );
};

export default errorsToString;



// WEBPACK FOOTER //
// ./src/tools/errorsToString.ts